<template>
    <!--后续可弃用-->
    <el-dialog  title="" :visible.sync="showBlock" :destroy-on-close="true" width='500px' :before-close="closedBtn">
        <SelectBlock ref="platform"   keyVal="platform" title="选择平台" value="" @getVal="getVal" :options="options"  placeholder="请选者平台"></SelectBlock>
        <div id="authority" class=" warp-teble">
          <div class="block">
              <el-tree  :data="tableData" ref="tree"  :check-strictly="true" show-checkbox node-key="id"  :default-expanded-keys="[]" :default-checked-keys="menuButtonIds"  :props="defaultProps"  @check-change="handleCheckChange"></el-tree>
          </div>
          <div class="warp-Btn">
             <el-button  @click="closedBtn">取消</el-button>
             <el-button type="primary" @click="submitBtn">确定</el-button>
          </div> 
        </div>
    </el-dialog>
</template>
<script>
  import { userApi,operate } from '@/utils/config'
  import { postFun,putFun} from '@/utils/httpFun'
  export default{
     data:()=>({
        showBlock:false,
        defaultProps: {
          children: 'childMBs',
          label: 'name'
        },
        menuButtonIds:[],
        platformID:0,
        rouleID:0,
        tableData: []
     }),
     props:{
        options:{
           type:Array,
        }
     },
     methods:{
        //获取选中的值
        getVal(ev){
           this.platformID = ev.indexNo
           this.getPList() 
        },
        openWindw(ev){
            this.showBlock = true
            this.rouleID = ev.id 
            if(this.options.length==0){
               return
            }
            for(var i in this.options){
              this[this.options[i].code]=[]
            }
            this.menuButtonIds = ev.mbIds
            console.log(ev.mbIds)
            this.platformID = this.options[0].indexNo
            this.$nextTick(res=>{
              this.$refs.platform.setVal(this.options[0].selectName)
            })
            this.getPList()
        },

        //获取对应平台的数据
        async getPList(){
          let parms = {
              id:0,                         //0根节点
              subsystemId:this.platformID   //平台id
          }
          await postFun(operate.MODULETREE,parms,res=>{
              this.tableData = res.data
          })
        },
       
        //提交更新
        async submitBtn(){
           let parms = {
               menuButtonIds:this.menuButtonIds,
               id:this.rouleID
           }
           parms.menuButtonIds = this.menuButtonIds
           parms.operator = this.$store.state.operator
           await putFun(userApi.ROULEUPDATE,parms,res=>{
                if(res.code==1){
                    this.showBlock = false
                    this.showBtn = false
                    this.$parent.serachBtn()
                }   
            })
        },
        
        //获取选中的值
        handleCheckChange(data,mark,ev3){
         console.log(data,mark,ev3)
          if(mark){
             this.menuButtonIds = [...this.menuButtonIds,...[data.id]]
             console.log(this.menuButtonIds)
          }else{
             this.menuButtonIds.splice(this.menuButtonIds.indexOf(data.id),1)
             console.log(this.menuButtonIds)
          }
        },

        //关闭
        closedBtn(){
           this.showBlock = false
        }
     }
  }
</script>
<style lang="scss" scoped>

    .warp-teble{
      margin-top: 20px;
    }
    .block{
       height: 400px;
       overflow-y: auto; 
    }
    .warp-Btn{
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
    }
    

</style>